import { translateSeriesName } from "@/common/utils/seriesNameTranslator";
import { DashboardComponentChartProps } from "@/features/company/types/dashboards/dashboardComponent.type";
import { numberTickFormatter } from "@/features/company/utils/dashboards/numberTickFormatter";
import { Fragment } from "react";
import { Area, AreaChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartTooltip } from "./components/ChartTooltip";

const AreaChartComponent = ({
  chartData,
}: DashboardComponentChartProps) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        data={chartData?.data}
        margin={{
          top: 10,
          bottom: 10,
          left: 15,
          right: 20,
        }}
      >
        <CartesianGrid
          strokeWidth={1}
          opacity={0.1}
          horizontal={true}
          vertical={false}
        />

        <YAxis
          width="auto"
          style={{ fontSize: 11 }}
          tickFormatter={numberTickFormatter}
        />

        <Tooltip
          cursor={{ fill: '#ffffff', opacity: 0.08 }}
          content={<ChartTooltip chartData={chartData} />}
        />

        <XAxis
          style={{ fontSize: 11 }}
          dataKey={chartData?.primary_settings?.query_identifier}
        />

        <Legend
          iconType="plainline"
          iconSize={12}
          wrapperStyle={{ fontSize: 11 }}
          labelStyle={{ color: '#ffffffaa' }}
          layout="horizontal"
          align="center"
          verticalAlign="bottom"
          formatter={(dataKey) => chartData?.series_settings[dataKey].label || translateSeriesName(dataKey)}
        />

        {chartData?.series_settings && Object.entries(chartData?.series_settings).map(([key, data]) => {
          const pointCount = (chartData?.data ?? []).filter(d => d[key] != null).length;

          return (
            <Fragment key={key}>
              <Area
                dataKey={key}
                fill={data.color + '55'}
                stroke={data.color}
                isAnimationActive
                type="monotone"
                fillOpacity={1}
                strokeWidth={2}
                dot={pointCount === 1}
                connectNulls
              />
            </Fragment>
          );
        })}
      </AreaChart>
    </ResponsiveContainer>
  );
}

export default AreaChartComponent;
